import {
  Box,
  Button,
  Card,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import 'swiper/css';
import 'swiper/css/free-mode';

import KakaoLoginModal from 'components/modal/kakaoLoginModal';
import ProfileStatsCard from 'page-sections/callmetellme/ProfileStatsCard';

// import { useSearchParams } from 'react-router-dom'; // Temporarily commented out

// lottie files

import FlexBox from 'components/flexbox/FlexBox';
import Footer from 'page-sections/callmetellme/Footer';
import Bookmark from '../../../page-sections/callmetellme/Bookmark';
import CallmeTellmeBottomBar from '../../../page-sections/callmetellme/CallmeTellmeBottomBar';
import CategoryPostList from '../../../page-sections/callmetellme/CategoryPostList';
import CommunityCategoryBox from '../../../page-sections/callmetellme/CommunityCategoryBox';
import JiwongumAICard from '../../../page-sections/callmetellme/JiwongumAIcard';
import KnowledgeHelper from '../../../page-sections/callmetellme/KnowledgeHelper';
import MonthlyPopularQuestions from '../../../page-sections/callmetellme/MonthlyPopularQuestions';
import ProfileStatsCardMobile from '../../../page-sections/callmetellme/ProfileStatsCardMobile';
import ReplyRanking from '../../../page-sections/callmetellme/ReplyRanking';
import PostListSearchSection from '../../../page-sections/callmetellme/mypage/PostListSearchSection';

const profileMenuData = [
  {
    text: '내 글',
    count: 10,
    path: '/naver/callmetellme/mypage/my-posts',
  },
  {
    text: '내 댓글',
    count: 0,
    path: '/naver/callmetellme/mypage/my-comments',
  },
  {
    text: '스크랩',
    count: 4,
    path: '/naver/callmetellme/mypage/bookmarked-posts',
  },
  {
    text: '출처',
    count: 3,
    path: '/naver/callmetellme/mypage/bookmarked-support-programs',
  },
];

export default function CategoryList() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  const [showKaKaoLoginModal, setShowKaKaoLoginModal] = useState(false);

  let padding;
  if (window.innerWidth > 1720 && !isTablet) {
    padding = '0px 0px';
  } else {
    padding = isTablet ? '0px 15px' : '0px 0px';
  }

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: padding,
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.lightGrey200,
      }}
    >
      <KakaoLoginModal
        showModal={showKaKaoLoginModal}
        setShowModal={setShowKaKaoLoginModal}
      />

      {isMobile && <CallmeTellmeBottomBar />}

      <Grid
        container
        xs={12}
        gap={isTablet ? 0 : 2}
        paddingX={!isDesktop ? '0px' : '120px'}
        justifyContent={'center'}
      >
        <Grid
          item
          xs={12}
          lg={1.5}
          sx={{
            position: isTablet ? 'static' : 'sticky',
            top: isTablet ? 'auto' : '76px',
            alignSelf: 'flex-start',
            height: 'fit-content',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              padding: isTablet ? '15px 0px 0px 0px' : '20px 0px 0px 0px',
              backgroundColor: theme.palette.primary.lightGrey200,
              borderRadius: 0,
              border: 'none',
              [theme.breakpoints.down('sm')]: {
                '& > .MuiBox-root': {
                  paddingBottom: 0,
                },
              },
            }}
          >
            <FlexBox gap={2} flexDirection={'column'}>
              <CommunityCategoryBox />
            </FlexBox>
          </Box>
        </Grid>

        <Grid item xs={12} lg={7.5}>
          <Grid container gap={'20px'} paddingTop={isTablet ? '20px' : '30px'}>
            <CategoryPostList />

            {/* <Box sx={{ padding: isMobile ? '0px 15px' : '0px 0px' }}> */}
            <PostListSearchSection />
            {/* </Box> */}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          lg={2.5}
          sx={{
            position: isTablet ? 'static' : 'sticky',
            top: isTablet ? 'auto' : '76px',
            alignSelf: 'flex-start',
            height: 'fit-content',
            paddingLeft: isTablet ? '16px' : '0px',
          }}
        >
          <Box
            sx={{
              width: '100%',
              padding: isTablet ? '15px 15px 0px 0px' : '30px 0px 0px 0px',
              backgroundColor: theme.palette.primary.lightGrey200,
              borderRadius: 0,
              border: 'none',
              [theme.breakpoints.down('sm')]: {
                '& > .MuiBox-root': {
                  paddingBottom: 0,
                },
              },
            }}
          >
            <FlexBox gap={2} flexDirection={'column'}>
              {!isTablet && <ProfileStatsCard data={profileMenuData} />}

              {!isTablet && (
                <Button
                  variant="contained"
                  sx={{
                    width: '100%',
                    height: '44px',
                    borderRadius: 4,
                    backgroundColor: theme.palette.primary.mainBlue,
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: theme.palette.primary.mainBlueHover,
                    },
                  }}
                >
                  글 작성
                </Button>
              )}

              <MonthlyPopularQuestions />
              {!isTablet && <Bookmark />}
              <KnowledgeHelper />
              <ReplyRanking />
              {!isTablet && <JiwongumAICard />}
              {isTablet && <ProfileStatsCardMobile data={profileMenuData} />}
            </FlexBox>
          </Box>
        </Grid>
      </Grid>

      <Box paddingBottom={isMobile ? '60px' : '0px'} backgroundColor="#EAEAEA">
        <Footer />
      </Box>
    </Box>
  );
}
